import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import router from "./router.js";
import App from "./App.vue";
import "./assets/app.css";
import "./assets/iconfont/iconfont.css";
import * as math from "mathjs";
window.mathFormat = math;
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);

Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});
let axios = require("axios");
Vue.prototype.$axios = window.axios = axios;
window.localAxios = axios.create({
  baseURL: process.env.VUE_APP_HOST_LOCAL + "/mix/v1",
  timeout: 8000,
});
let moment = require("moment");
moment.locale("zh-cn");
window.moment = moment;
window.echarts = require("echarts");
import "echarts/extension/bmap/bmap";
Vue.use(ElementUI);
Vue.use(vuescroll);
Vue.use(router);
import tool from "./tool.js";
Vue.use(tool);
import VueCropper from "vue-cropper";
// import "vue-cropper/example/asset/prism.css";
Vue.use(VueCropper);

require("./utils/bn");
import digits from "./directive/digits";
Vue.directive("digits", digits);

import QRCode from "qrcodejs2";

// window.oss_url = 'https://cloud-api-dev.dwood365.com/';
window.oss_url = process.env.VUE_APP_OSS;
window.baseURL = process.env.VUE_APP_HOST;
// window.baseURL = 'https://cloud-api-dev.dwood365.com/mix/v1/';
axios.defaults.baseURL = window.baseURL + "/mix/v1/";
axios.interceptors.request.use(
  function(config) {
    if (localStorage.hasOwnProperty("dw_erp_user_token")) {
      config.headers.Token =
        "Bearer " + localStorage.getItem("dw_erp_user_token");
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

window.localAxios.interceptors.request.use(
  function(config) {
    if (localStorage.hasOwnProperty("dw_erp_user_token")) {
      config.headers.Token =
        "Bearer " + localStorage.getItem("dw_erp_user_token");
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

if (localStorage.dw_erp_user_id) {
  let qimName =
    localStorage.dw_erp_user_name +
    "(" +
    localStorage.dw_erp_company_name +
    ")";
  window.qimoClientId = {
    userId: localStorage.dw_erp_user_id, // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
    priority: false, //是否优先进线设置，非必填，值为boolean类型的true或false
    nickName: qimName, //自定义用户昵称，定义用户昵称则userId必传
  };
}

Vue.filter("dateFormat_", (date) => {
  if (date) {
    return moment(parseInt(date) * 1000).format("YYYY-MM-DD HH:mm:ss");
  } else {
    return "";
  }
});

Vue.filter("dateFormat", (date) => {
  if (date) {
    return moment(parseInt(date) * 1000).format("YYYY-MM-DD");
  } else {
    return "";
  }
});

Vue.config.productionTip = false;

Vue.prototype.pl = function(log) {
  //   window.console.log(log)
};

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
